import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyledCloseWSError } from './styles';
import { useNavigate } from 'react-router-dom';

export const CloseWSError = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledCloseWSError>
      <div>
        {t('errors.close_ws_error')}
      </div>
      <div className='link' onClick={() => navigate('/')}>
        {t('errors.go_to_main_page')}
      </div>
      </StyledCloseWSError>
  )
}
